import { CORE_TOKEN_LOGOS } from './default-tokens'

/**
 * Logos the app has seen, by token address, kept across reloads (John, Nov 5
 * 2026: a strategy chip read "HE" for Hellhound while the holdings row beside
 * it showed the logo; "fix the logos everywhere"). A chip or row that comes
 * without a logo reads it from here before asking the server for it.
 */
const KEY = 'dispence.logos'
const CAP = 400
let memory: Record<string, string> | null = null

function load(): Record<string, string> {
  if (memory) return memory
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(KEY) ?? '{}')
    memory = parsed && typeof parsed === 'object' ? (parsed as Record<string, string>) : {}
  } catch {
    memory = {}
  }
  return memory
}

export function rememberLogo(address: string, url: string) {
  if (CORE_TOKEN_LOGOS[address]) return
  const logos = load()
  if (logos[address] === url) return
  const keys = Object.keys(logos)
  if (keys.length >= CAP) for (const key of keys.slice(0, keys.length - CAP + 1)) delete logos[key]
  logos[address] = url
  try {
    localStorage.setItem(KEY, JSON.stringify(logos))
  } catch {
    // storage full or blocked: the logo lives for this page only
  }
}

export function recallLogo(address: string | undefined | null): string | undefined {
  if (!address) return undefined
  return CORE_TOKEN_LOGOS[address] ?? load()[address]
}
